import axios from 'axios';

export function apiDeleteRequisite( id) {
  return axios.delete(`/requisites/${id}/`)

}